import React, {Component, useContext, useState} from 'react';
import PropTypes from 'prop-types';
import {Formik} from "formik";
import {BootstrapError, BootstrapField} from "../../../helpers/Field";
import * as yup from 'yup';
import {InvoicesContext} from "../../invoice/InvoiceDataManager";
import {validateAccount} from "../../../requests/UserRequests";
import AutoLinkAccountSuccess from "./AutoLinkAccountSuccess";
import AutoLinkAccountError from "./AutoLinkAccountError";
import AutoLinkAccountForm from "./AutoLinkAccountForm";



function AutoLinkAccount(props) {
  let [status, setStatus] = useState("form");
  let [invoice, setInvoice] = useState(null);
  let [errorMessage, setErrorMessage] = useState("");

  return (
    <div>
      {status === "success" && <AutoLinkAccountSuccess invoice={invoice} onClear={() => {
        setStatus("form");
        setInvoice(null);
      }}/>}
      {status === "error" && <AutoLinkAccountError onClear={() => {
        setStatus("form");
        setInvoice(null);
      }} message={errorMessage}/>}
      {status === "form" && <AutoLinkAccountForm
        onSuccess={(invoice) => {
          setStatus("success");
          setInvoice(invoice.detail);
          props.onAccountAdded();
        }}
        onError={(message) => {
          setStatus("error");
          setErrorMessage(message);
        }}
      />
      }
    </div>
  );
}
AutoLinkAccount.propTypes = {
  onAccountAdded: PropTypes.func,
};

export default AutoLinkAccount;
